import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.less'],
})
export class RadioButtonComponent implements OnInit, OnChanges {

  /**
   * 数据源
   * {title:显示内容,value:选择数据,alt:提示信息{icon:提示icon,style:icon样式,text:提示内容}}
   */
  @Input() data: Array<object> = [];
  /**
   * 双向绑定
   *  选中的选项的value
   */
  @Input() check: any = '';
  @Output() checkChange = new EventEmitter();
  /**
   * 设置radio单个的宽度
   */
  @Input() width: string = '';
  /**
   * 单个radiobutton 样式
   */
  @Input() itemStyle: object = {};

  @Input() checkPoint: boolean = true;
  // tslint:disable-next-line:no-output-native
  @Output() change = new EventEmitter();

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.check == undefined) {
      for (const i of this.data) {
        if (i['disabled'] != true) {
          this.check = i['value'];
          break;
        }
      }
    }
  }

  ngOnInit(): void {
    console.log(this.data)

  }

  /**
   * 选择radio
   */
  checkRadio(): void {
    this.checkChange.emit(this.check);
    this.change.emit(this.check);
  }
}
